import styled from 'styled-components';
import { BorderRadius, mediaQueries } from '@theme/lib';

export const smCustomBreakpoint = '@media screen and (min-width: 480px)';
export const mdCustomBreakpoint = '@media screen and (min-width: 708px)';
export const lgCustomBreakpoint = '@media screen and (min-width: 1120px)';
export const xlCustomBreakpoint = '@media screen and (min-width: 1593px)';

export const StyledVideo = styled('div')<{ videoType: string }>`
  max-width: ${(props) => props.videoType == "shorts" ?'80%' : undefined};
  margin: ${(props) => props.videoType == "shorts" ? '0 auto': undefined};
  ${smCustomBreakpoint} {
    max-width:  ${(props) => props.videoType == "shorts" ? '60%' : undefined};
  }
  ${mediaQueries.lg} {
    max-width:  ${(props) => props.videoType == "shorts" ?'100%' : undefined};
  }
  iframe {
    width: 100%;
    aspect-ratio: ${(props) => props.videoType == "shorts" ? '9 / 16': '16 / 9'};
    ${(props) => BorderRadius(props.theme.config.componentRadius)};
    ${mediaQueries.md} {
      aspect-ratio: 16 / 9;
    }
  }
`;
